import { Box, Grid } from "@mui/material";
import React from "react";
import ScenarioInfoForm from "./ScenarioInfoForm";
import SkuPgSearchForm from "./SkuPgSearchForm";
import SkuPgSearchResult from "./SkuPgSearchResult";
import CustomerCgSearchForm from "./CustomerCgSearchForm";
import CustomerCgSearchResult from "./CustomerCgSearchResult";
import DefineLinkDataSources from "./DefineLinkDataSources";
import DefineScenarioSettings from "./DefineScenarioSettings";
import CustomerBdMethod from "./CustomerBdMethod";
import Summary from "./Summary";
import DefaultSafetyMargin from "./DefaultSafetyMargin";
import MessageForCreate from "./MessageForCreate";
import { ConstrainedForecastSection, UnconstrainedForecastSection } from "./PredictionMethod";
import AuthorizedDeviation from "./AuthorizedDeviation";
import ExportExcelPDF from "./ExportExcelPDF";
import { setState, reset } from "../scenarioSetupNewSlice";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import CollapseSection from "../../../../components/ui/CollapseSection";
import ScenarioValidationPopUpCreate from "./ScenarioValidationPopupCreate";
import dayjs from "dayjs";

export default function CreateScenario() {

	const dispatch = useDispatch();
	const setupState = useSelector((store) => store.scenarioSetupNew);
	const {
		isCopyScenario,predictionMethodPeriodList,previousYearPeriodList,DefaultInitialForecast,
	} = setupState;
	useEffect(() => {
		if(!isCopyScenario){
			dispatch(reset("refresh"))
		}
		else{
			dispatch(setState("isCopyScenario", false));
		}
	},[]);
	

	return (
		<Box>
			<Box>
				<MessageForCreate />
			</Box>
			<ScenarioValidationPopUpCreate />
			<ScenarioInfoForm />
			<CollapseSection title="Select SKUs/Product Groups">
			{/* isError = {section_SKU} */}
			<Grid container spacing={2}>
				<Grid item lg={2.25} xs = {12}>
					<SkuPgSearchForm />
				</Grid>
				<Grid item lg={9.75} xs = {12} >
					<SkuPgSearchResult />
				</Grid>
			</Grid>
			</CollapseSection>
			<CollapseSection title="Select Customer Groups/Customers">
					{/*isError = {section_Customer} */}
			<Grid container spacing={2}>
				<Grid item lg={2.25} xs = {12}>
					<CustomerCgSearchForm />
				</Grid>
				<Grid item lg={9.75} xs = {12}>
					<CustomerCgSearchResult />
				</Grid>
			</Grid>
			</CollapseSection>
			<CollapseSection title="Define and Link Data Sources">
					{/*isError = {section_Datasources} */}
				<DefineLinkDataSources />
			</CollapseSection>
			<CollapseSection title="Define Scenario Settings">
					{/*isError = {section_Scenario_Settings} */}
			<Grid container spacing={2}>
				<Grid item lg={12} xs={12}>
				<UnconstrainedForecastSection />
				<ConstrainedForecastSection />
				<AuthorizedDeviation />
				<DefineScenarioSettings />
				<DefaultSafetyMargin />
				<CustomerBdMethod />
				</Grid>
			</Grid>
			</CollapseSection>
			<Summary />
		</Box>
	);
}
